// Tambahkan fungsi-fungsi ini ke file helpers/api.js

import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllUndangan(params: any): any {
  const baseUrl = "/api/admin/invitation";
  return api.get(`${baseUrl}`, params);
}

function ApiPostUndangan(params: any): any {
  const baseUrl = "/api/admin/invitation";
  return api.create(`${baseUrl}`, params);
}

function ApiPostUndanganEmail(params: any): any {
  const baseUrl = "/api/admin/invitation-by-email";
  return api.create(`${baseUrl}`, params);
}

function ApiEditUndangan(id: any, params: any): any {
  const baseUrl = "/api/admin/invitation/" + id;
  return api.update(`${baseUrl}`, params);
}

function ApiDeleteUndangan(id: any, params: any): any {
  const baseUrl = "/api/admin/invitation/" + id;
  return api.delete(`${baseUrl}`, params);
}

export {
  ApiGetAllUndangan,
  ApiPostUndangan,
  ApiEditUndangan,
  ApiDeleteUndangan,
  ApiPostUndanganEmail,
};
